import React, { useState } from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import { processOperationsCsvs } from "../../../../api";
import "./styles.scss";

const CsvInput = ({ type, file, handleCsvChange }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <label htmlFor={`${type}-csv`}>
        <span className="file-input-button">
          {formatMessage({ id: "escolher-arquivo" })}
        </span>
        <p>{file?.name || formatMessage({ id: "arquivo-nao-escolhido" })}</p>
      </label>

      <input
        type="file"
        id={`${type}-csv`}
        accept=".csv"
        onChange={e => handleCsvChange(e, type)}
      />
    </div>
  );
};

const ImportOperationsModal = ({ onClose, onSuccess, onError }) => {
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState({
    operacoes: "",
    areas: ""
  });

  async function onClickHandler() {
    setIsLoading(true);

    const fileKeys = Object.keys(files);
    const formData = new FormData();

    for (let fileKey of fileKeys) {
      formData.set(fileKey, files[fileKey]);
    }

    try {
      await processOperationsCsvs(formData);

      onSuccess();
    } catch (err) {
      onError(formatMessage({ id: "erro-api" }));
      onClose();
    }
  }

  const handleCsvChange = (e, type) => {
    const files = e.target.files;

    if (files.length === 0) return;

    const file = files[0];

    setFiles(oldFiles => ({ ...oldFiles, [type]: file }));
  };

  return (
    <>
      <div className="modal import-operations-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "importar-csv-operacoes" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            <div className="csv-input-wrapper">
              {formatMessage({ id: "csv-operacoes" })}
              <CsvInput
                type="operacoes"
                file={files.operacoes}
                handleCsvChange={handleCsvChange}
              />
            </div>
            <div className="csv-input-wrapper">
              {formatMessage({ id: "csv-areas" })}
              <CsvInput
                type="areas"
                file={files.areas}
                handleCsvChange={handleCsvChange}
              />
            </div>
          </section>
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={onClickHandler}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ImportOperationsModal;
